import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

/**
 * Where Google sends a practitioner back after she chooses "Continue with Google" on her
 * invitation. The invite token rides along in the query string; the Google session_id comes
 * back in the fragment.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const InviteGoogleCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('Claiming your account…');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    (async () => {
      const sessionId = new URLSearchParams(window.location.hash.replace('#', '')).get('session_id');
      const token = params.get('token');

      if (!sessionId || !token) {
        toast.error('That sign-in could not be completed. Open your invitation link again.');
        navigate('/');
        return;
      }

      try {
        const { data } = await axios.post(`${API}/auth/invite/${token}/google`, {
          session_id: sessionId,
        });
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        toast.success('Your account is yours — a few things to read and sign next');
        setStatus('Taking you to your onboarding…');
        window.location.href = '/dashboard/practitioner-onboarding';
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Your account could not be claimed');
        navigate(`/practitioner-invite?token=${token}`);
      }
    })();
    // Runs once: the Google session_id is single use.
  }, []);   // eslint-disable-next-line

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950">
      <div className="space-y-4 text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-cyan-400 border-t-transparent" />
        <p className="text-lg text-cyan-200" data-testid="invite-google-status">{status}</p>
      </div>
    </div>
  );
};

export default InviteGoogleCallback;
